import { render, staticRenderFns } from "./suoritemerkinta.vue?vue&type=template&id=be7fb4f0&scoped=true&"
import script from "./suoritemerkinta.vue?vue&type=script&lang=ts&"
export * from "./suoritemerkinta.vue?vue&type=script&lang=ts&"
import style0 from "./suoritemerkinta.vue?vue&type=style&index=0&id=be7fb4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7fb4f0",
  null
  
)

export default component.exports